(ns frontend.view.entity-merge.view
  (:require
   [basic-components.modal :as zap-modal]
   [basic-components.step-indicator :as step-indicator]
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entity-type-names :as etn]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.view.entity-merge.associations :as associations]
   [frontend.view.entity-merge.attachments :as attachments]
   [frontend.view.entity-merge.components :as components]
   [frontend.view.entity-merge.entity-info :as entity-info]
   [frontend.view.entity-merge.events :as events]
   [frontend.view.entity-merge.guests :as guests]
   [frontend.view.entity-merge.kyc :as kyc]
   [frontend.view.entity-merge.review :as review]
   [ui.components.button.view :as button]
   [ui.components.modal.style :as modal-style]
   [frontend.view.modals.events :as modals]
   [reagent.core :as r]
   [ui.components.modal.view :as modal]
   [ui.editors.data-input :as data-input]))

(defn next-from
  [xs current]
  (let [found (->> xs
                   (drop-while (complement #{current}))
                   rest)
        val (if (seq found)
              (first found)
              (first xs))]
    val))

(defn previous-from
  [xs current]
  (next-from (reverse xs) current))

(defn step-content
  [[kw args] index current-index last?]
  (let [current? (= index current-index)
        seen? (< index current-index)
        num (inc index)]
    [:div

     {:class-name
      (fu/cs
       "step-content d-flex justify-content-center align-items-center pl-2 text-color--light-grey"
       (when current? "active text-color--white"))}
     (cond
       last?
       [:span.state-indicator__icon.mr-2
        [:i.fas.fa-flag]]

       seen?
       [:span.state-indicator__icon
        num]

       current?
       [:span.state-indicator__icon.mr-2
        num]

       :else
       [:span num])
     (when current?
       [:span.state-indicator__text.d-flex.flex-column.justify-content-start.text-left
        (case kw
          :entity-info
          (loc/tr :entity-type-info [(loc/tr args)])

          :associations
          (loc/tr :entity-type-associations [(loc/tr args)])

          :attachments
          (loc/tr :attachments)

          :guests
          (loc/tr :guests)

          :kpi
          (loc/tr :kpi-reports)

          :kyc-profiles
          (loc/tr :kyc-profiles)

          :review
          (loc/tr :entity-merge/review-result)

          (str "error"))])]))

(defn debug-view
  [{:keys [state] :as signals}]
  (let [{:keys [hide-debug?]} @state
        step-defs (events/steps signals)
        current-step (or (:current-step @state)
                         (first step-defs))]
    (when-not hide-debug?
      [:div.debug-container--will-be-removed
       [:span.clickable
        {:style    {:border "1px solid black"}
         :on-click (fn [_]
                     (swap! state update :hide-debug? not))}
        "hide-these"]
       [:span.clickable
        {:style    {:border "1px solid black"}
         :on-click (fn [_]
                     (swap! state assoc :current-step (previous-from step-defs current-step)))}
        "previous"]
       [:span.clickable
        {:style    {:border "1px solid black"}
         :on-click (fn [_]
                     (swap! state assoc :current-step (next-from step-defs current-step)))}
        "next"]])))

(defn merging-view
  [{:keys [_state]}]
  [:div.merging
   [:div
    [:div.text-center.py-4
     [:img {:src "/img/Merging-in-process.svg"}]

     [:strong.d-block.text-bold.py-4
      (loc/tr :entity-merge/merging)]]]])

(defn error-view
  [{:keys [state]}]
  [:div.merging
   [:div
    [:div.text-center.py-4
     ;; uncomment for quicker testing:
     ;;{:on-click #(swap! state dissoc :error?)}
     [:strong.d-block.text-bold.py-4
      [:span (loc/tr :something-went-wrong) " "
       [:a {:href (str "mailto:" (loc/tr :support-email-address))}
        (loc/tr :support-email-address)]]]
     (when-let [msg (:error-message @state)]
       [:div
        {:class "mt-2"}
        "(" msg ")"])]]])

(defn merge-view
  [{:keys [r-source r-target r-first-entity r-second-entity] :as signals}
   {:keys [source-id target-id state entity-type close-modal!] :as args}]
  (let [source @r-source
        target @r-target
        step-defs (->> (events/steps signals)
                       (remove (partial events/empty-step? signals)))
        [current-step-kw current-step-params :as current-step] (or (:current-step @state)
                                                                   (first step-defs))
        current-index (.indexOf step-defs current-step)
        review? (= current-step-kw :review)
        first-step? (= current-step-kw (ffirst step-defs))
        entity-info? (= current-step-kw :entity-info)
        steps (doall
               (->> step-defs
                    (map-indexed (fn [i [kw args :as step]]
                                   {:key        step
                                    :class-name (when (< i current-index)
                                                  "state-indicator__item--done")
                                    :content    [step-content step i current-index
                                                 (= step (last step-defs))]}))))]
    [:<>
     [:div
      {:class "flex-1 overflow-auto"}
      [:div
       ;; uncomment to help development:
       #_[debug-view signals]
       [:div
        {:class "p-3"}
        [:div
         {:class "flex justify-center"}
         [step-indicator/view
          {:steps        steps
           :current-step current-step}]]]
       [:div
        (when entity-info?
          [:div
           {:class "p-3 font-bold border-b border-solid border-base-light-border-paler"}
           [:div
            [components/step-info signals current-step]]])

        [:div
         {:class "p-3"}
         (when-not (or review? entity-info?)
           [:<>
            [:div.asset-updater-table__title.p-2 ;;.my-3
             [:div
              {:class-name "grid grid-cols-12 gap-4 px-4"}
              [:div
               {:class-name "col-span-5"}
               [:strong (entity/display-string source :long)]
               [:div.text-size--sm.py-2 (loc/tr :entity-merge-discarded)]]
              [:div
               {:class-name "col-span-2 flex justify-center"}
               [:div.zap-button--link.zap-button--link-white
                [:i.fal.fa-arrow-right]]]
              [:div
               {:class-name "col-span-5"}
               [:strong (entity/display-string target :long)]
               [:div.text-size--sm.py-2 (loc/tr :entity-merge-saved)]]]]])
         (when-not (or review? entity-info?)
           [:div.card-container__header
            [:div.merge-content-info
             [components/step-info signals current-step]]])
         (case current-step-kw
           :entity-info
           [entity-info/view signals]

           :associations
           ;;force remount every time step changes:
           ^{:key (str "association-step-" current-step-kw current-step-params)}
           [associations/view signals]

           :attachments
           [attachments/view signals]

           :guests
           [guests/view signals]

           :kyc-profiles
           [kyc/profiles-view signals]

           ;;not used for first release:
           ;;:kpi
           ;;[kpi/view signals]

           :review
           [review/view signals]

           [:div "not-implemented"])]]]]
     [modal/footer-left-and-right
      [[button/secondary-hollow
        {:on-click   (fn [_]
                       (close-modal!)
                       (swap! state assoc :current-step (previous-from step-defs current-step)))}
        [:span
         (loc/tr :cancel)]]]
      (concat []
              (when-not first-step?
                [[button/primary-solid
                  {:on-click   (fn [_]
                                 (swap! state assoc :current-step (previous-from step-defs current-step)))}
                  [:span
                   (loc/tr :previous-step)]]])
              (when-not review?
                [[button/primary-solid
                  {:class "ml-3"
                   :on-click   (fn [_]
                                 (swap! state assoc :current-step (next-from step-defs current-step)))}
                  [:span
                   (loc/tr :next-step)]]])
              (when review?
                [[button/primary-solid
                  {:class "ml-3"
                   :on-click   (fn [_]
                                 (events/merge! signals close-modal!))}
                  [:span
                   (loc/tr :entity-merge/confirm-and-merge)]]]))]]))

(defn merge-view-initial
  [signals {:keys [close-modal! state target source]}]
  ;;current values of target and source can be saved to state here if we want to implement a notification
  ;; when entities have been modified during the merge process:
  ;;(swap! state assoc :initial-entities (index-by :db/id [target source]))
  (fn [signals {:keys [close-modal! state target source] :as args}]
    (cond (:merging? @state)
          [merging-view signals]

          (:error? @state)
          [error-view signals]

          :else
          [merge-view signals args])))

(defn merge-view-wrapper
  [signals
   {:keys [entity-type close-modal! state
           target-id source-id first-entity-id second-entity-id]
    :as   args}]
  (let [{:keys [target-id source-id]} @state
        target @(r/track events/get-entity target-id)
        source @(r/track events/get-entity source-id)
        first-entity @(r/track events/get-entity source-id)
        second-entity @(r/track events/get-entity target-id)
        found? (and target source)
        target-type (:entity/type target)
        source-type (:entity/type source)
        same-type? (and target-type
                        source-type
                        (= entity-type target-type source-type))]
    (cond (not found?)
          [:div "Entity not found. Maybe it was deleted?"]

          (not same-type?)
          [:div (loc/tr :both-must-be [(string/lower-case (etn/get-plural entity-type :en))])]

          :else
          [merge-view-initial signals (assoc args :target target :source source)])))

;; TODO remove later? left for reference (for now):
(defn entity-selector
  [{:keys [close-modal! state first-entity-id second-entity-id disabled-ids] :as args}]
  (let [first-entity (events/get-entity first-entity-id)
        pipeline-id (:oppo/pipeline first-entity)
        pipeline (events/get-entity pipeline-id)
        {:keys [source-id target-id]} @state]
    [:div
     [:div.d-flex.justify-content-center.merge-selector-container
      [:div.linkable-entity-search
       [:div "Merge"]
       [:div.select-area
        [data-input/view
         {:editor-type :editor.type/select
          :data-type   :data.type/ref-single
          :value       target-id
          :options     (->> @session/all-oppos
                            (cu/filter-by :oppo/pipeline pipeline-id)
                            (cu/remove-by :db/id source-id)
                            (mapv (fn [o]
                                    {:value (:db/id o)
                                     :label (entity/display-string o)})))
          :disabled?   (contains? disabled-ids target-id)
          :placeholder (loc/tr :select)
          :on-change   (fn [new-value & _]
                         (swap! state assoc :target-id new-value))}]]]
      [button/secondary-open
       {:on-click   (fn [_]
                      (swap! state
                             (fn [{:keys [target-id source-id] :as state}]
                               (assoc state
                                      :source-id target-id
                                      :target-id source-id))))}
       ;;TODO replace with the correct icon:
       [:i.fal.fa-exchange]]
      [:div.entity-type-selector
       [:div "To"]
       [data-input/view
        {:editor-type :editor.type/select
         :data-type   :data.type/ref-single
         :value       source-id
         :options     (->> @session/all-oppos
                           (cu/filter-by :oppo/pipeline pipeline-id)
                           (cu/remove-by :db/id target-id)
                           (mapv (fn [o]
                                   {:value (:db/id o)
                                    :label (entity/display-string o)})))
         :disabled?   (contains? disabled-ids source-id)
         :placeholder (loc/tr :select)
         :on-change   (fn [new-value & _]
                        (swap! state assoc :source-id new-value))}]]]
     [:div
      {:on-click (fn [_]
                   (swap! state update :selected? not))}
      "set-selected (" (str (:selected? @state)) ")"]
     [:i.fas.fa-code-merge]
     [:div "target-id: " (:target-id @state)
      " source-id: " (:source-id @state) " "]]))

(defn initial
  [signals
   {:keys [close-modal! state first-entity-id second-entity-id entity-type] :as args}]
  ;; signals calculation added here for shadow-cljs:
  (let [signals (events/create-signals! {:state       state
                                         :entity-type entity-type})]
    (r/create-class
     {:component-will-unmount
      (fn [_])
      :reagent-render
      (fn [_ {:keys [target-id source-id] :as args}]
        (let [{:keys [target-id source-id selected?]} @state]
          ;; no longer using entity selection step:
          (cond (or (not target-id)
                    (not source-id)
                    #_(not selected?))
                [entity-selector args]

                :else
                [merge-view-wrapper signals args])))})))

(defn open-merge-modal!
  [entity-type first-entity-id second-entity-id]
  (let [type-name-plural (etn/get-plural entity-type :en)
        ;; Note: lower-casing won't work for e.g. German:
        type-name-plural (string/lower-case type-name-plural)
        state (r/atom {:entity-type       entity-type
                       :show-empty-steps? true
                       :first-entity-id   first-entity-id
                       :second-entity-id  second-entity-id
                       :source-id         first-entity-id
                       :target-id         second-entity-id})
        signals (events/create-signals! {:state       state
                                         :entity-type entity-type})]
    (modals/open-modal!
     zap-modal/modal-key
     {:title   (loc/tr :entity-merge-title [type-name-plural])
      :size    ::modal-style/full
      :content (fn [close-modal!]
                 [initial signals
                  {:close-modal!     close-modal!
                   :state            state
                   :entity-type      entity-type
                   :first-entity-id  first-entity-id
                   :disabled-ids     (->> [first-entity-id second-entity-id]
                                          (remove nil?)
                                          set)
                   :second-entity-id second-entity-id}])})))
